(function () {
  'use strict';

  function activatePlayer(player) {
    if (!player || player.dataset.activated === 'true') return;
    var mode = player.getAttribute('data-sv-mode');
    var media = player.querySelector('[data-sv-media]');
    if (!media) return;

    if (mode === 'youtube' || mode === 'vimeo' || mode === 'external') {
      var embed = player.getAttribute('data-sv-embed') || player.getAttribute('data-sv-file-url');
      if (!embed) return;
      var iframe = document.createElement('iframe');
      iframe.className = 'sv-player__iframe';
      iframe.src = embed;
      iframe.title = 'Video player';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.setAttribute('loading', 'eager');
      media.innerHTML = '';
      media.appendChild(iframe);
    } else if (mode === 'file') {
      var url = player.getAttribute('data-sv-file-url');
      if (!url) return;
      var video = document.createElement('video');
      video.className = 'sv-player__video';
      video.src = url;
      video.controls = true;
      video.playsInline = true;
      video.autoplay = player.getAttribute('data-sv-autoplay') === '1';
      media.innerHTML = '';
      media.appendChild(video);
      if (video.autoplay) {
        try { video.play(); } catch (e) { /* noop */ }
      }
    } else {
      return;
    }

    player.dataset.activated = 'true';
  }

  function init(container) {
    if (!container || container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    var buttons = container.querySelectorAll('[data-sv-play]');
    function onClick(e) {
      var btn = e.currentTarget;
      activatePlayer(btn.closest('[data-sv-player]'));
    }
    buttons.forEach(function (b) { b.addEventListener('click', onClick); });

    container._lviCleanup = function () {
      buttons.forEach(function (b) { b.removeEventListener('click', onClick); });
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._lviCleanup === 'function') container._lviCleanup();
    container.dataset.bound = '';
  }

  function bootAll() {
    document.querySelectorAll('[data-section-type="lo-video-intro"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-section-type="lo-video-intro"]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-section-type="lo-video-intro"]').forEach(destroy);
  });
})();
